import {
  ANALYTICS_PAGE,
  EDITORIAL_PAGE,
  HOSTED_WATCH_PAGE,
  LIVE_PAGE,
  MARKETPLACE_DASHBOARD_PAGE,
  PLAYER_PAGE,
} from '@/modules/@common/router/constants/index';

export const DEFAULT_PAGES_MAP = {
  ANALYTICS: ANALYTICS_PAGE.path,
  VIDEO_MANAGER: EDITORIAL_PAGE.path,
  WATCH: HOSTED_WATCH_PAGE.path,
  LIVE: LIVE_PAGE.path,
  PLAYER: PLAYER_PAGE.path,
  MARKETPLACE: MARKETPLACE_DASHBOARD_PAGE.path,
};

export type DEFAULT_PAGES_MAP_TYPE = typeof DEFAULT_PAGES_MAP;

export default {};
